module.exports = __webpack_public_path__ + "assets/images/park-01.2a476f3a92aceaa88d3654763fe1ae4f.svg";